import { useState } from 'react';
import { Box, Typography, Stack } from '@mui/material';
import { useClient } from '../../../../context/ClientContext';
import StepsHeading from '../../common/StepsHeading';

export default function BloodPressure( { userData, setUserData, onNext } ) {
  const { theme, clientId } = useClient();
  const [ error, setError ] = useState( null );

  const handleOptionSelect = ( value ) => {
    // Update userData with the selected blood pressure value
    setUserData( prev => ( {
      ...prev,
      bloodPressure: value
    } ) );

    // Proceed to the next step through the standard flow
    onNext();
  };

  return (
    <Stack spacing={ 3 } alignItems="center">
      <StepsHeading title={ "What is your blood pressure?" } />

      <Box
        sx={ {
          display: "flex",
          flexDirection: "column",
          width: {
            xs: "280px",
            sm: "300px",
            md: "400px",
            lg: "450px"
          },
          gap: 2
        } }
      >
        {/* Blood pressure selection buttons */ }
        <Box
          onClick={ () => handleOptionSelect( 'normal' ) }
          sx={ {
            width: '100%',
            height: {
              xs: '55px',
              md: '70px'
            },
            backgroundColor: userData.bloodPressure === 'normal' ? theme.primaryColor : "rgba(26, 26, 26, 0.08)",
            marginBottom: "8px",
            borderRadius: '10px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
            transition: 'all 0.2s ease-in-out',
            color: userData.bloodPressure === 'normal' ? "white" : '#000',
            '&:hover': {
              transform: 'scale(1.02)',
              color: 'white',
              backgroundColor: theme.primaryColor,
            }
          } }
        >
          <Typography
            sx={ {
              fontSize: {
                xs: '14px',
                sm: '16px',
                md: '18px'
              },
              fontWeight: '400',
              textAlign: 'center'
            } }
          >
            <Typography sx={ { fontWeight: 'bold' } }>Normal</Typography>
            Less than 120 mmHg
          </Typography>
        </Box>

        <Box
          onClick={ () => handleOptionSelect( 'prehypertension' ) }
          sx={ {
            width: '100%',
            height: {
              xs: '55px',
              md: '70px'
            },
            backgroundColor: userData.bloodPressure === 'prehypertension' ? theme.primaryColor : "rgba(26, 26, 26, 0.08)",
            marginBottom: "8px",
            borderRadius: '10px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
            transition: 'all 0.2s ease-in-out',
            color: userData.bloodPressure === 'prehypertension' ? "white" : '#000',
            '&:hover': {
              transform: 'scale(1.02)',
              color: 'white',
              backgroundColor: theme.primaryColor,
            }
          } }
        >
          <Typography
            sx={ {
              fontSize: {
                xs: '14px',
                sm: '16px',
                md: '18px'
              },
              fontWeight: '400',
              textAlign: 'center'
            } }
          >
            <Typography sx={ { fontWeight: "bold" } }>Prehypertension</Typography>
            120 - 139 mmHg
          </Typography>
        </Box>

        <Box
          onClick={ () => handleOptionSelect( 'hypertension' ) }
          sx={ {
            width: '100%',
            height: {
              xs: '55px',
              md: '70px'
            },
            backgroundColor: userData.bloodPressure === 'hypertension' ? theme.primaryColor : "rgba(26, 26, 26, 0.08)",
            marginBottom: "8px",
            borderRadius: '10px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
            transition: 'all 0.2s ease-in-out',
            color: userData.bloodPressure === 'hypertension' ? "white" : '#000',
            '&:hover': {
              transform: 'scale(1.02)',
              color: 'white',
              backgroundColor: theme.primaryColor,
            }
          } }
        >
          <Typography
            sx={ {
              fontSize: {
                xs: '14px',
                sm: '16px',
                md: '18px'
              },
              fontWeight: '400',
              textAlign: 'center'
            } }
          >
            <Typography sx={ { fontWeight: "bold" } }>Hypertension </Typography>
            More than 140 mmHg
          </Typography>
        </Box>

        { error && (
          <Typography
            variant="caption"
            color="error"
            display="flex"
            textAlign="start"
            gutterBottom
            sx={ {
              fontSize: {
                xs: '12px',
                sm: '12px',
                md: '16px',
                lg: '16px',
              },
              padding: '10px 0px 0px 0px',
              gutterBottom: true,
            } }
          >
            { error }
          </Typography>
        ) }
      </Box>
    </Stack>
  );
}